<template>
    <div :class="{'view-default-header': !isSmallWindow}">
        <div class="view-default-header__container">
            <h1 class="view-default-header__title">
                {{title}}
            </h1>
            <div>
                {{profileName}}
                <p 
                    @click="onClickLogout"
                    class="btn_exit"
                >
                    Выйти
                </p>
            </div>
        </div>
        <div class="view-default-header__bottom">
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import mixinAdaptive from '../../mixins/mixinAdaptive';
import serviceAuth from '../../services/serviceAuth';
export default {
    name: 'ViewDefaultHeader',
    mixins: [
        mixinAdaptive
    ],
    /**
     * @property {object} profile - профиль
     */
    data: () => ({
        profile: {}
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} title - заголовок страницы
         */
        ...mapState({
            title: state => state.ModuleView.currentViewName
        }),
        /**
         * имя юзера
         * @returns {string}
         */
        profileName() {
            let {name = '', surname = ''} = this.profile;
            return `${name} ${surname}`;
        }
    },
    mounted() {
        // получаем профиль
        this.profile = serviceAuth.getProfile();
    },
    methods: {
        /**
         * Событие logout
         * @async
         */
        async onClickLogout() {
            let {succes = false, error = false} = await serviceAuth.logout();
            if (succes) {
                this.$router.push({name: 'check-phone'});
            }
            else if (error) {
                alert("не удалось выйти");
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .view-default-header {
        // position: -webkit-sticky;
        // position: sticky;
        top: 0;
        z-index: 2;
    }
    .view-default-header__container {
        display: flex;
        justify-content: space-between;
        padding: 0 25px;
        background: #fff;
        border-radius: 14px;
        align-items: center;
    }
    .view-default-header__bottom {
        height: 10px;
    }
    .view-default-header__title {
        font-size: 1.5385rem;
        font-weight: 400;
        margin: 16px 10px 16px 0;
    }
    .btn_exit {
        cursor: pointer;
        margin: 0;
    }
    .btn_exit:hover {
        transition: .3s;
        color: #fe1060;
    }
</style>